import { FaPlay } from "react-icons/fa";

interface PlayProps {
  acao: () => void;
  setTooltipLeft?: (left: number) => void;
  setTooltipTop?: (top: number) => void;
  setTooltipConteudo?: (conteudo: string | JSX.Element) => void;
  setTooltipWidth?: (width: number) => void;
  setShowTooltip?: (show: boolean) => void;
  mensagemTooltip?: NullableString;
}
export function Play({
  acao,
  setTooltipLeft = () => {},
  setTooltipTop = () => {},
  setTooltipConteudo = () => {},
  setTooltipWidth = () => {},
  setShowTooltip = () => {},
  mensagemTooltip = null,
}: PlayProps) {
  if (!mensagemTooltip) {
    return <FaPlay style={{ cursor: "pointer" }} onClick={acao} />;
  }

  return (
    <span
      onMouseEnter={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        const { left, top } = event.currentTarget.getBoundingClientRect();
        setTooltipLeft(left);
        setTooltipTop(top);
        setTooltipConteudo(mensagemTooltip);
        setTooltipWidth(95);
        setShowTooltip(true);
      }}
      onMouseLeave={() => {
        setShowTooltip(false);
        setTooltipLeft(0);
        setTooltipTop(0);
        setTooltipConteudo("");
      }}
    >
      <FaPlay style={{ cursor: "pointer" }} onClick={acao} />
    </span>
  );
}
